import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Barcode = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M20,17 L20,20 L17,20 L17,19 L19,19.001 L19,17 L20,17 Z M6,17 L5.999,19 L8,19 L8,20 L5,20 L5,17 L6,17 Z M9,8 L9,16 L7,16 L7,8 L9,8 Z M16,8 L16,16 L14,16 L14,8 L16,8 Z M11,8 L11,16 L10,16 L10,8 L11,8 Z M13,8 L13,16 L12,16 L12,8 L13,8 Z M18,8 L18,16 L17,16 L17,8 L18,8 Z M8,4 L8,5 L6,4.999 L6,7 L5,7 L5,4 L8,4 Z M20,4 L20,7 L19,7 L19.001,5 L17,5 L17,4 L20,4 Z" })));
};
export default Barcode;
